// One registration table drives filters and forms. Stable identifiers are open strings;
// later leagues/sports can be registered without duplicating UI branches or game data.
export const SPORTS_REGISTRY = {
  sports: [
    { id: 'kpop', en: 'K-pop', ko: 'K-pop' }, { id: 'running', en: 'Running', ko: '러닝' },
    { id: 'baseball', en: 'Baseball', ko: '야구' }, { id: 'basketball', en: 'Basketball', ko: '농구' },
    { id: 'soccer', en: 'Soccer', ko: '축구' }, { id: 'american_football', en: 'American football', ko: '미식축구' },
  ],
  countries: ['KR', 'JP', 'US', 'CA', 'TW'],
  leagues: [
    { id: 'kbo', sport: 'baseball', countries: ['KR'], name: 'KBO' },
    { id: 'npb', sport: 'baseball', countries: ['JP'], name: 'NPB' },
    { id: 'mlb', sport: 'baseball', countries: ['US', 'CA'], name: 'MLB' },
  ],
};
export function sportName(id, locale) { return SPORTS_REGISTRY.sports.find(value => value.id === id)?.[locale] || id; }
export function countryName(id, locale) { try { return new Intl.DisplayNames([locale], { type: 'region' }).of(id); } catch { return id; } }
export function dimensionOptions(seasons) {
  return {
    sports: [...new Set([...SPORTS_REGISTRY.sports.map(value => value.id), ...seasons.map(value => value.sport)])],
    countries: [...new Set([...SPORTS_REGISTRY.countries, ...seasons.flatMap(value => value.countries)])],
    leagues: [...new Set([...SPORTS_REGISTRY.leagues.map(value => value.id), ...seasons.map(value => value.league)])],
    seasons: [...new Set(seasons.map(value => value.season))],
  };
}
